import React from "react";
import { useState } from "react";

const DialogoEnviarWhatsapp = (params) => {
  const [telefono, setTelefono] = useState("");
  const [indicativo, setIndicativo] = useState("57");

  function cambiarTelefono(e) {
    setTelefono(e.target.value);
  }

  function cambiarIndicativo(e) {
    setIndicativo(e.target.value);
  }

  function enviarMensaje() {
    document.getElementById("btnCloseModalEnviarWhatsapp").click();
    let href =
      "https://api.whatsapp.com/send?phone=" + indicativo + telefono + "&text=";
    window.open(
      href,
      "nuevo",
      "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=800, height=600"
    );
  }

  return (
    <div
      className="modal fade"
      id="dialogoEnviarWhatsapp"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              Enviar mensaje a whatsapp
            </h5>
            <button
              className="btn btn-outline-danger btn-sm"
              id="btnCloseModalEnviarWhatsapp"
              data-dismiss="modal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x-lg"
                viewBox="0 0 16 16"
                 style={{ color: "red" }}
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <div className="container">
              <div className="row">
                <div className="col-4">
                  <input
                    style={{ width: "100%" }}
                    className="rounded"
                    type="number"
                    onChange={cambiarIndicativo}
                    placeholder="Indicativo"
                    value={indicativo}
                  ></input>
                </div>
                <div className="col-8">
                  <input
                    style={{ width: "100%" }}
                    className="rounded"
                    type="number"
                    onChange={cambiarTelefono}
                    placeholder="Número télefono"
                  ></input>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={enviarMensaje}
              type="button"
              className="btn btn-success btn-sm"
            >
              Enviar mensaje
            </button>
            <button
              style={{ display: "none" }}
              id="btnOpenModalEnviarWhatsapp"
              type="button"
              data-toggle="modal"
              data-target="#dialogoEnviarWhatsapp"
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogoEnviarWhatsapp;
